import { render, staticRenderFns } from "./ReviewUploadDlg.vue?vue&type=template&id=0194bc70&scoped=true"
import script from "./ReviewUploadDlg.vue?vue&type=script&lang=js"
export * from "./ReviewUploadDlg.vue?vue&type=script&lang=js"
import style0 from "./ReviewUploadDlg.vue?vue&type=style&index=0&id=0194bc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194bc70",
  null
  
)

export default component.exports